import { render, staticRenderFns } from "./ListCompare.vue?vue&type=template&id=08903bb5"
import script from "./ListCompare.vue?vue&type=script&lang=js"
export * from "./ListCompare.vue?vue&type=script&lang=js"
import style0 from "./ListCompare.vue?vue&type=style&index=0&id=08903bb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports